<template>
  <div class="content-wrap">
    <NaviBox ref="childNaviBoxRef"/>
    <div class="tit-group02">
      <h2 class="tit">{{t('message.monitoringManagement')}}</h2>
    </div>
    <div class="content-box">
      <div class="sort-group">
        <div class="sort-row">
          <div class="wl">
            <div class="txt-total">Total: {{ totalCnt }}</div>
            <c-InputSearch :placeholder="t('message.searchMultiPlaceholder')" v-model="inputSearch" @search-word="onClickSearch"/>
          </div>
          <div class="wr">
            <c-btn01 :btnText="t('message.newRegistration')" @click="onClickViewPage"/>
          </div>
        </div>
      </div>
      <!-- v-data-table 가져옴-->
      <div class="tbl-group size-custom8">
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="items"
          :items-per-page-options="footerOptions"
          return-object
          show-select
          @click:row="onClickViewPage"
        >
          <template v-slot:item.monitoringTitle="{ item }" >
            <div class="flex-l">
              <v-btn variant="text">
                <div class="ell01">
                  {{item.monitoringTitle}}
                </div>
              </v-btn>
            </div>
          </template>
          <template v-slot:item.period="{ item }" >
            <div class="flex-c">
              {{dayjs(item.startDate).format('YYYY-MM-DD') == 'Invalid Date' ? '':dayjs(item.startDate).format('YY.MM.DD')}}
              ~{{dayjs(item.endDate).format('YYYY-MM-DD') == 'Invalid Date' ? '':dayjs(item.endDate).format('YY.MM.DD')}}
            </div>
          </template>
          <template v-slot:item.btnCopy="{ item }">
            <div class="flex-c">
              <c-btnText01 :btnText="t('message.copy')" @click.prevent.stop="onClickCopy(item.idx)"/>
            </div>
          </template>
          <template v-slot:item.activeYn="{ item }">
            <div class="flex-c">
              {{item.activeYn=='Y'?t('message.activate'):t('message.deactivate')}}
            </div>
          </template>
        </v-data-table>
      </div>
      <div class="bottom-btn-group">
        <div class="wl"></div>
        <div class="wr">
          <c-btnLine01 :btnText="t('message.bulkChangeTarget')"  @click="onClickChangeMember"/>
          <c-btnLine01 :btnText="t('message.bulkChangeStatus')"  @click="onClickChangeActive"/>
          <c-btn02 :btnText="t('message.bulkHide')" @click="onClickChangeShow"/>
          <c-btn02 :btnText="t('message.bulkDelete')"  @click="onClickDelete"/>
        </div>
      </div>
    </div>
  </div>
 <!--
  <c-dialog v-model="dialogSubjectChangeModel"
            v-bind="dialogSubjectChangeBind"
            @close="dialogSubjectChangeModel=false"
  />
  -->
  <!--일괄 대상자 변경-->
  <DialogTargetAdd2
    v-model="dialogChangeModel"
    @close="dialogChangeModel=false"
    @confirm="confirmChangeMember"
  />
  <c-dialog v-model="dialogCopyModel"
            v-bind="dialogCopyBind"
            @close="dialogCopyModel=false"
            @cancel="cancelCopy"
            @confirm="confirmCopy"
  />
  <c-dialog v-model="dialogActiveChangeModel"
            v-bind="dialogActiveChangeBind"
            @close="dialogActiveChangeModel=false"
            @cancel="cancelChangeActive"
            @confirm="confirmChangeActive"
  />
  <c-dialog v-model="dialogShowChangeModel"
            v-bind="dialogShowChangeBind"
            @close="dialogShowChangeModel=false"
            @cancel="cancelChangeShow"
            @confirm="confirmChangeShow"
  />
  <c-dialog v-model="dialogAllDeleteModel"
            v-bind="dialogAllDeleteBind"
            @close="dialogAllDeleteModel=false"
            @confirm="confirmDelete"
  />
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useCommonStore } from "@/store/common";
import BbsService from "@/services/bbs.service";
import utils from "@/common/Utils";
import dayjs from "dayjs";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)

//bind
const snackbar = ref(false)
const snackText = ref('')
const totalCnt = ref(0)
const inputSearch = ref(null)
const dialogChangeModel = ref(false)
const dialogCopyModel = ref(false)
const dialogActiveChangeModel = ref(false)
const dialogShowChangeModel = ref(false)
const dialogAllDeleteModel = ref(false)
const selected = ref([])
const items = ref([])
const childNaviBoxRef = ref(null)

//ui
const dialogCopyBind = {
  dialogTit: t('message.copyMonitoring'),
  dialogText: t('message.copyMonitoringDescription'),
  btn1Text: t('message.copyWithTargets'),
  btn1Show: true,
  btn2Text: t('message.copyWithoutTargets'),
  btn2Show: true,
}
const dialogActiveChangeBind = {
  dialogTit: t('message.changeMonitoringStatus'),
  dialogText: t('message.changeMonitoringStatusDescription'),
  btn1Text: t('message.activate'),
  btn1Show: true,
  btn2Text: t('message.deactivate'),
  btn2Show: true,
}
const dialogShowChangeBind = {
  dialogTit: t('message.changeMonitoringVisibility'),
  dialogText: t('message.changeMonitoringVisibilityDescription'),
  btn1Text: t('message.hide'),
  btn1Show: true,
  btn2Text: t('message.show'),
  btn2Show: true,
}
const dialogAllDeleteBind = {
  dialogTit: t('message.deleteMonitoring'),
  dialogText: t('message.deleteMonitoringDescription'),
  btn1Text: t('message.delete'),
  btn1Show: true,
  btn2Text: t('message.cancel'),
  btn2Show: true,
}
const headers = ref([
  { title: t('message.monitoringName'), key: 'monitoringTitle' },
  { title: t('message.targetCount'), key: 'targetCnt' },
  { title: t('message.period'), key: 'period'},
  { title: t('message.status'), key: 'activeYn' },
  { title: t('message.copy'), key: 'btnCopy' },
])
const footerOptions = [
  { value: 5, title: '5' },
  { value: 10, title: '10' },
  { value: 25, title: '25' },
  { value: 50, title: '50' },
  { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' }
]

//hook
let copyIdx = null
onMounted(() => {
  onClickSearch()
})

//function
const onClickSearch = ()=>{
  let companyIdx = localStorage.getItem('companyIdx')
  const word = inputSearch.value
  let params = {
    keyword: word,
    companyIdx:companyIdx,
  }

  BbsService.getBbsList(params).then(
    (response) => {
      items.value = response.result
      totalCnt.value = items.value.length
      selected.value = []
    },
    (error) => {
      if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
    }
  )
}
const onClickCopy = (idx)=>{
  dialogCopyModel.value=true
  copyIdx = idx
}

const cancelCopy = ()=>{
  if(import.meta.env.MODE == 'development') {
    snackText.value = 'success'
    snackbar.value = true
  }
  else{
    procCopy('N')
  }
}

const confirmCopy = ()=>{
  if(import.meta.env.MODE == 'development') {
    snackText.value = 'success'
    snackbar.value = true
  }
  else{
    procCopy('Y')
  }
}

const procCopy = (type)=>{
  let companyIdx = localStorage.getItem('companyIdx')
  if(!companyIdx)
    utils.movePage('/login')

  let params = {
    companyIdx:companyIdx,
    idx: copyIdx,
    copyTargetYn:type
  }

  BbsService.copyBbs(params).then(
    (response) => {
      if(response.success) {
        snackText.value = 'success'
        snackbar.value = true
        onClickSearch()
      }
      else{
        snackText.value = response.message
        snackbar.value = true
      }
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const onClickChangeMember = ()=>{
  if(selected.value.length <= 0){
    snackText.value = t('message.noDataSelected')
    snackbar.value = true
  }
  else {
    storeRef.popupItems.value = selected.value
    storeRef.popupItems2 = null
    storeRef.popupType.value = 'all'
    dialogChangeModel.value = true
  }
}

const confirmChangeMember = (param)=>{
  dialogChangeModel.value=false
  let companyIdx = localStorage.getItem('companyIdx')
  let monitoringTargets = param
  let updateArr = []
  selected.value.forEach((item)=>{
    updateArr.push(item.idx)
  })
  let params = {
    companyIdx:companyIdx,
    monitoringTargets:monitoringTargets,
    updateArr:updateArr
  }

  BbsService.updateMonitoringTarget(params).then(
    (response) => {
      if(response.success)
        snackText.value = 'success'
      else
        snackText.value = 'fail'
      snackbar.value = true
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const onClickChangeShow = ()=>{
  if(selected.value.length <= 0){
    snackText.value = t('message.noDataSelected')
    snackbar.value = true
  }
  else
    dialogShowChangeModel.value = true
}

const cancelChangeShow = ()=>{
  //dialogShowChangeModel.value = false
  updateColumn('showYn', 'Y')
}

const confirmChangeShow = ()=>{
  updateColumn('showYn', 'N')
}

const onClickChangeActive = ()=>{
  if(selected.value.length <= 0){
    snackText.value = t('message.noDataSelected')
    snackbar.value = true
  }
  else
    dialogActiveChangeModel.value = true
}

const cancelChangeActive = ()=>{
  //dialogActiveChangeModel.value = false
  updateColumn('activeYn', 'N')
}

const confirmChangeActive = ()=>{
  updateColumn('activeYn', 'Y')
}

const onClickDelete = ()=>{
  if(selected.value.length <= 0){
    snackText.value = t('message.noDataSelected')
    snackbar.value = true
  }
  else {
    if(selected.value.length)
    dialogAllDeleteModel.value = true
  }
}

const confirmDelete = ()=>{
  if(import.meta.env.MODE == 'development') {
    selected.value.forEach((item)=>{
      const idx = items.value.findIndex(function(tempItem) {return tempItem.idx === item.idx})
      if (idx > -1) items.value.splice(idx, 1)
    })

    snackText.value = 'success'
    snackbar.value = true
  }
  else{
    let companyIdx = localStorage.getItem('companyIdx')
    if(!companyIdx)
      utils.movePage('/login')

    let updateArr = []
    selected.value.forEach((item)=>{
      updateArr.push(item.idx)
    })
    let params = {
      companyIdx:companyIdx,
      updateArr: updateArr,
    }

    BbsService.deleteBbs(params).then(
      (response) => {
        if(response.success) {
          selected.value.forEach((item)=>{
            const idx = items.value.findIndex(function(tempItem) {return tempItem.idx === item.idx})
            if (idx > -1) items.value.splice(idx, 1)
          })

          selected.value = []
          snackText.value = 'success'
          snackbar.value = true
        }
        else{
          snackText.value = response.message
          snackbar.value = true
        }
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
}

const onClickViewPage = (event, row)=>{
  if(row)
    storeRef.viewIdx.value = row.item.idx
  else
    storeRef.viewIdx.value = null
  utils.movePage('/monitoringManagementListDetail/'+storeRef.viewIdx.value)
}

const updateColumn = (columnKey, columnValue)=>{
  if(import.meta.env.MODE == 'development') {
    selected.value.forEach((item)=>{
      const idx = items.value.findIndex(function(tempItem) {return tempItem.idx === item.idx})
      if (idx > -1) items.value.splice(idx, 1)
    })

    snackText.value = 'success'
    snackbar.value = true
  }
  else{
    let companyIdx = localStorage.getItem('companyIdx')
    if(!companyIdx)
      utils.movePage('/login')

    let updateArr = []
    selected.value.forEach((item)=>{
      updateArr.push(item.idx)
    })
    let params = {
      companyIdx:companyIdx,
      updateArr: updateArr,
      updateColumnKey: columnKey,
      updateColumnValue: columnValue,
    }

    BbsService.updateColumnBbs(params).then(
      (response) => {
        if(response.success) {
          onClickSearch()
          snackText.value = 'success'
          snackbar.value = true
        }
        else{
          snackText.value = response.message
          snackbar.value = true
        }
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
}

//즐겨찾기 버튼 삭제, 사용안함
const onChangeCheck = (item, e)=>{
  let user = JSON.parse(localStorage.getItem('user'))
  let params = {
    bookmarkType:'m',
    parentIdx:item,
    memberIdx:user.memberIdx,
  }

  if(e.target.checked){
    BbsService.insertBookmark(params).then(
      (response) => {
        if (childNaviBoxRef.value)
          childNaviBoxRef.value.loadData('bookmark')
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
  else{
    BbsService.deleteBookmark(params).then(
      (response) => {
        if (childNaviBoxRef.value)
          childNaviBoxRef.value.loadData('bookmark')
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
}
</script>


<style lang="scss" scoped>
.tbl-group{
  th:nth-child(2)>div{justify-content:flex-start !important;padding-left:5rem}
  td:nth-child(2){width:45%;}
  td:nth-child(4){width:20%;}
}
</style>
